/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {Block} from 'baseui/block'
import {StyledLink} from 'baseui/link'
import {Modal, ModalBody, ModalButton, ModalFooter, ModalHeader, SIZE} from 'baseui/modal'
import Markdown from 'markdown-to-jsx'
import React, {useEffect, useState} from 'react'

const MdLink = ({children, ...props}) => <StyledLink {...props}>{children}</StyledLink>

const CopyrightModal = props => {
  const {isModalOpen, toggleModal, content} = props
  const [mdContent, setMdContent] = useState('')

  useEffect(() => {
    import(`../../content/${content}.md`)
      .then(file => {
        return fetch(file.default)
      })
      .then(response => {
        return response.text()
      })
      .then(md => {
        setMdContent(md)
      })
  }, [content])

  return (
    <Modal
      onClose={toggleModal}
      isOpen={isModalOpen}
      size={SIZE.auto}
      unstable_ModalBackdropScroll
      overrides={{
        Dialog: {
          style: {
            maxWidth: '60rem',
            display: 'flex',
            flexDirection: 'column',
          },
        },
        Root: {
          style: {
            zIndex: '4',
          },
        },
      }}
    >
      <ModalHeader>Little Robot Friends Inc.</ModalHeader>
      <ModalBody>
        <Block
          overrides={{
            Block: {
              style: ({$theme}) => ({
                overflowY: 'scroll',
                maxHeight: '40vh',
                [$theme.media.large]: {
                  maxHeight: '60vh',
                },
              }),
            },
          }}
        >
          <Markdown
            options={{
              overrides: {
                a: {
                  component: MdLink,
                  props: {
                    target: '_blank',
                    rel: 'noopener noreferrer',
                  },
                },
              },
            }}
          >
            {mdContent}
          </Markdown>
        </Block>
      </ModalBody>
      <ModalFooter>
        <ModalButton onClick={toggleModal}>Close</ModalButton>
      </ModalFooter>
    </Modal>
  )
}

export default CopyrightModal
